class ApiError extends Error {
  constructor() {
    super('API_ERROR');
    this.name = 'API_ERROR';
  }
}

export default ApiError;
